import React from "react";
import { useAuthStore } from "stores/authStore/authStore";
import { H3 } from "components/Typography/text.styled";
import { LoaderProgress } from "components/icon/loaderProgress.component";

export const ProfilePage = () => {
  const [authState] = useAuthStore();

  return authState.isLoading ? (
    <LoaderProgress />
  ) : (
    <H3>Profile</H3>
  );
};
